/**
 * Generate a Langfuse session URL for an appointment.
 * Returns empty string if Langfuse is not configured (use this to determine button visibility).
 */
export const getLangfuseSessionUrlForAppointment = (
  appointmentId: string,
  baseUrl?: string | null,
  projectId?: string | null,
): string => {
  if (!baseUrl || !projectId) {
    return '';
  }

  return `${baseUrl}/project/${projectId}/sessions/${appointmentId}`;
};
